export default __webpack_public_path__ + "static/media/studentsPoster.7e8fe0b8.JPG";